/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  PackageSimple,
  PackageSimpleFromJSON,
  PackageSimpleFromJSONTyped,
  PackageSimpleToJSON,
} from "./";

/**
 *
 * @export
 * @interface PackageSimpleGroup
 */
export interface PackageSimpleGroup {
  /**
   *
   * @type {number}
   * @memberof PackageSimpleGroup
   */
  minDays?: number;
  /**
   *
   * @type {Array<PackageSimple>}
   * @memberof PackageSimpleGroup
   */
  packages: Array<PackageSimple>;
}

export function PackageSimpleGroupFromJSON(json: any): PackageSimpleGroup {
  return PackageSimpleGroupFromJSONTyped(json, false);
}

export function PackageSimpleGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PackageSimpleGroup {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    minDays: !exists(json, "minDays") ? undefined : json["minDays"],
    packages: (json["packages"] as Array<any>).map(PackageSimpleFromJSON),
  };
}

export function PackageSimpleGroupToJSON(
  value?: PackageSimpleGroup | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    minDays: value.minDays,
    packages: (value.packages as Array<any>).map(PackageSimpleToJSON),
  };
}
